import { lazy } from "react";
import { createPortal } from "react-dom";
import { CookieNotice } from "@questy/aura-cl";
import { useEmailMessageModal } from "./hooks/useEmailMessageModal";
import { useIncomingCallSettings } from "./hooks/useIncomingCallSettings";
import { useTaskModal } from "./hooks/useTaskModal";
import { isInAuraContext } from "./pages/desktop/utils";
import useCookieNoticeSettings from "./hooks/useCookieNoticeSettings";
import CustomScripts from "./CustomScripts";
const Nav = lazy(() => import("./feature/nav"));
const CallPopover = lazy(() => import("./feature/incoming-call"));

if (process.env.NODE_ENV === "development" && !isInAuraContext()) {
  const devMenuMountPoint = `<div id="aura-menu-root" />`;
  document.body.insertAdjacentHTML("afterbegin", devMenuMountPoint);

  const devIncomingCallMountPoint = `<div id="aura-incoming-call-root" />`;
  document.body.insertAdjacentHTML("afterbegin", devIncomingCallMountPoint);
}

const menuMountPoint = document.getElementById(
  "aura-menu-root"
) as HTMLDivElement;
const incomingCallMountPoint = document.getElementById(
  "aura-incoming-call-root"
) as HTMLDivElement;
const cookieNoticeMountPoint = document.body;

/**
 * Komponent pomocniczy pozwalający odseparować montowanie elementów
 * dostępnych globalnie na `window` od elementów interfejsu użytkownika.
 */
const AppAux = () => {
  useEmailMessageModal();
  useTaskModal();
  const dateraEnabled = useIncomingCallSettings();
  const cookieNoticeEnabled = useCookieNoticeSettings();

  return (
    <>
      {menuMountPoint ? createPortal(<Nav />, menuMountPoint) : null}
      {dateraEnabled && incomingCallMountPoint
        ? createPortal(<CallPopover />, incomingCallMountPoint)
        : null}
      {cookieNoticeEnabled && cookieNoticeMountPoint
        ? createPortal(<CookieNotice />, cookieNoticeMountPoint)
        : null}
      <CustomScripts />
    </>
  );
};

export default AppAux;
